
	import { Observer } from 'mobx-vue';
	import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
	import PrescriptionItem from '@/components/new-prescription/prescription-items/PrescriptionItem.vue';
	import PrescriptionItemWrapper from '@/components/new-prescription/prescription-items/PrescriptionItemWrapper.vue';

	@Observer
	@Component({
		components: { PrescriptionItemWrapper }
	})
	export default class PrescriptionItemSpecialRXTile extends Vue {
		@Prop({ required: true }) specialRX!: string;
	}
